<template>
  <div>
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <!-- 系统账号 -->
        <div class="item">
          <el-input v-model="datas.username" :placeholder="$t('message.systemAccount')"></el-input>
        </div>
        <!-- 姓名 -->
        <div class="item">
          <el-input v-model="datas.realname" :placeholder="$t('message.name')"></el-input>
        </div>
        <!-- 电话 -->
        <div class="item">
          <el-input v-model="datas.mobile" :placeholder="$t('message.phone')"></el-input>
        </div>
        <!-- ID -->
        <div class="item">
          <el-input v-model="datas.id" :placeholder="$t('message.employeeId')"></el-input>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
        <!--  检品比例批量分配-->
        <div class="btn"> <el-button type="primary" class="primary" @click="batchAllocationOfInspectionProportion">
            {{ $t('message.batchAllocationOfInspectionProportion')
            }}</el-button></div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 选择 -->
          <li class="flex05" @click="allCheck" style="cursor: pointer;">
            {{ $t('message.choose') }}
            <!-- <el-checkbox v-model="checked" @change="allCheck"></el-checkbox> -->
          </li>
          <!-- 系统账号 -->
          <li>{{ $t('message.systemAccount') }}</li>
          <!-- 账号类别 -->
          <li>{{ $t('message.typeOfAccount') }}</li>
          <!-- 真实姓名 -->
          <li>{{ $t('message.realname') }}</li>
          <!-- 性别 -->
          <li>{{ $t('message.sex') }}</li>
          <!-- 电话 -->
          <li>{{ $t('message.phone') }}</li>
          <!-- 检品属性 -->
          <li class="flex3">{{ $t('message.checkProductAttributes') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData " :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 选择 -->
          <li class="flex05">
            <el-checkbox v-model="item.checked"></el-checkbox>
          </li>
          <!-- 系统账号 -->
          <li>{{ item.username }}</li>
          <!-- 账号类别 -->
          <li>{{ item.is_transient != 1 ? '正式员工' : '临时工' }}</li>
          <!-- 真实姓名 -->
          <li>{{ item.realname }}</li>
          <!-- 性别 -->
          <li>{{ item.sex == 1 ? '男' : '女' }}</li>
          <!-- 电话 -->
          <li>{{ item.mobile }}</li>
          <!-- 检品属性 -->
          <li class="flex3">
            <div class="jinpin">
              <div class="row" v-for="(items, indexs) in item.role" :key="indexs">
                <p>{{ items.name }}</p>
                <div class="list">
                  <div class="item">普检:
                    <span :class="{ redBig: items.inspect_config && items.inspect_config.normal_inspect_rate > 0 }">{{
                      items.inspect_config ?
                        items.inspect_config.normal_inspect_rate : '' }}</span>
                  </div>
                  <div class="item"> 精细:
                    <span :class="{ redBig: items.inspect_config && items.inspect_config.careful_inspect_rate > 0 }">{{
                      items.inspect_config ?
                        items.inspect_config.careful_inspect_rate : '' }}</span>
                  </div>
                  <div class="item"> 布标:
                    <span :class="{ redBig: items.inspect_config && items.inspect_config.label_rate > 0 }">{{
                      items.inspect_config ?
                        items.inspect_config.label_rate : '' }}</span>
                  </div>
                  <div class="item">FBA:
                    <span :class="{ redBig: items.inspect_config && items.inspect_config.fba_rate > 0 }">{{
                      items.inspect_config ?
                        items.inspect_config.fba_rate : '' }}</span>
                  </div>
                </div>
              </div>
            </div>

          </li>
          <!-- 操作 -->
          <li>
            <!-- 检品属性 -->
            <el-button type="primary" @click="checkProductAttributes([item])"> {{ $t('message.checkProductAttributes')
              }}</el-button>
          </li>
        </ul>
      </div>
      <!-- 检品属性配置 -->
      <el-dialog :title="$t('message.configurationOfInspectionProperties')" :close-on-click-modal="false"
        :visible.sync="dialogVisible" width="1000px" center>
        <div class="attributeList table">
          <ol>
            <!-- 真是姓名 -->
            <li>{{ $t('message.realname') }}</li>
            <!-- 角色 -->
            <li>{{ $t('message.role') }}</li>
            <!-- 检品属性 -->
            <li style="flex:8">{{ $t('message.checkProductAttributes') }}</li>
          </ol>
          <div class="nameRow" v-for="(row, rowIndex) in attributeList" :key="rowIndex">
            <div class="name">
              {{ row.realname }}
            </div>
            <div class="table">
              <ul v-for="(item, index) in row.inspect_config" :key="index">
                <!-- 角色 -->
                <li style="text-align: center;">{{ item.name }}</li>
                <!-- 检品属性 -->
                <li style="flex:8">
                  <div>
                    <div class="row">
                      <div class="items">
                        {{ $t("message.checkProductAttributes") }}
                      </div>
                      <div class="items">
                        <el-checkbox v-model="item.enable_normal_inspect">普通检品</el-checkbox>
                      </div>
                      <div class="items">
                        <el-checkbox v-model="item.enable_careful_inspect">精细检品</el-checkbox>
                      </div>
                      <div class="items">
                        <el-checkbox v-model="item.enable_label">布标处理</el-checkbox>
                      </div>
                      <div class="items">
                        <el-checkbox v-model="item.enable_fba">FBA</el-checkbox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="items">
                        {{ $t("message.allocationProportion") }}
                      </div>
                      <div class="items">
                        <el-input v-model="item.normal_inspect_rate" size="mini" type="number"></el-input>
                      </div>
                      <div class="items">
                        <el-input v-model="item.careful_inspect_rate" size="mini" type="number"></el-input>
                      </div>
                      <div class="items">
                        <el-input v-model="item.label_rate" size="mini" type="number"></el-input>
                      </div>
                      <div class="items">
                        <el-input v-model="item.fba_rate" size="mini" type="number"></el-input>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!-- 保存 -->
          <el-button type="primary" @click="setInspectRate">{{
            $t("message.save")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      checked: false,
      datas: {
        work_type: '6',
        is_transient: '',
        username: '',
        realname: '',
        mobile: '',
        id: '',
        pageSize: 1000,
        page: 1
      },
      tableData: [],
      total: 0,
      attributeList: []
    };
  },
  created() {
    this.inspectList()
  },

  methods: {
    inspectList() {
      this.$api.roleApi.inspectList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false
        })
        this.tableData = res.data.data

      })
    },
    search() {
      this.datas.page = 1;
      this.inspectList()
    },
    //更新页数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.inspectList();
    },
    //更新分页每页数量
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.inspectList();
    },
    //检品属性
    checkProductAttributes(list) {
      this.attributeList = [];
      list.forEach(item => {
        let attribute = {
          realname: item.realname,
          inspect_config: []
        }
        item.role.forEach((items) => {
          if (items.inspect_config) {
            items.inspect_config.role_id = items.id;
            items.inspect_config.name = items.name;
            items.inspect_config.realname = item.realname;
            attribute.inspect_config.push(items.inspect_config)
          } else {
            attribute.inspect_config.push({
              admin_id: item.id,
              role_id: items.id,
              name: items.name,
              enable_normal_inspect: false,
              enable_careful_inspect: false,
              enable_label: false,
              enable_fba: false,
              normal_inspect_rate: "",
              careful_inspect_rate: "",
              label_rate: "",
              fba_rate: "",
              realname: item.realname,
            });
          }

        });
        this.attributeList.push(JSON.parse(JSON.stringify(attribute)));
      })
      this.dialogVisible = true
    },
    // 账号-检品属性设置(批量
    setInspectRate() {
      let datas = {
        list: [],
      };
      console.log(1);

      this.attributeList.forEach((row) => {
        row.inspect_config.forEach(item => {
          console.log(item.enable_normal_inspect ? item.normal_inspect_rate : 0);


          datas.list.push({
            admin_id: item.admin_id,
            role_id: item.role_id,
            enable_normal_inspect: item.enable_normal_inspect ? 1 : 0,
            enable_careful_inspect: item.enable_careful_inspect ? 1 : 0,
            enable_label: item.enable_label ? 1 : 0,
            enable_fba: item.enable_fba ? 1 : 0,
            normal_inspect_rate: item.enable_normal_inspect ? item.normal_inspect_rate : 0,
            careful_inspect_rate: item.enable_careful_inspect ? item.careful_inspect_rate : 0,
            label_rate: item.enable_label ? item.label_rate : 0,
            fba_rate: item.enable_fba ? item.fba_rate : 0,
          });
        })

      });
      this.$api.roleApi.setInspectRate(datas).then((res) => {
        this.$message.success(res.msg);
        this.inspectList();
        this.dialogVisible = false;
      });
    },
    //检品比例批量分配
    batchAllocationOfInspectionProportion() {
      let list = []
      this.tableData.forEach(item => {
        if (item.checked) {
          list.push(item)
        }
      })
      if (list == false) return this.$message.error(this.$t('message.selectableOperationalList'))
      this.checkProductAttributes(list)
    },
    //全选
    allCheck() {
      this.checked = !this.checked
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
      this.$forceUpdate()
    }
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .item {
    width: 200px;
    margin-right: 20px;
  }

  .btn {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.table {
  margin: 20px 0;

  .flex05 {
    flex: 0.5
  }

  .flex3 {
    flex: 3
  }
}

.jinpin {
  width: 100%;

  .row {
    margin-bottom: 5px;
    width: 100%;
    text-align: left;
  }

  .list {
    display: flex;

    .item {
      margin-right: 10px;

      .redBig {
        color: #B4272D;
        font-weight: 600;
        font-size: 18px;
      }
    }
  }
}

.attributeList {
  /deep/.el-checkbox__inner {
    transform: scale(1.5) !important;
  }

  ol {
    border: 1px solid #ccc;
  }

  .nameRow {
    display: flex;

    border: 1px solid #ccc;
    border-top: 0;

    .name {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #ccc;

    }

    .table {
      flex: 9;
      margin: 0;
    }

    ul {
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 5px;

        &:nth-child(1) {
          border-right: 1px solid #ccc;
        }
      }
    }
  }

  .row {
    margin-bottom: 10px;
    display: flex;

    .label {
      width: 150px;
      line-height: 40px;
      margin: 0px;
    }

    .items {
      flex: 1;
      margin-right: 15px;
      line-height: 28px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
}
</style>